import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { clearProgress } from '../../../redux/progress/progressAction';

export interface ProgressCleanerPropies {
    clearProgress: () => void;
    index: number;
}


function ProgressCleaner(props: ProgressCleanerPropies) {

    useEffect(() => {
        props.clearProgress();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.index]);

    return <>
    </>;
}

const mapStateToProps = (state: {
    user: { userName: string }
    project: { activeName: string }
}) => {
    return {
        userName: state.user.userName,
        activeProjectName: state.project.activeName
    };
};

export default connect(
    mapStateToProps,
    { clearProgress }
)(ProgressCleaner);